import { useState } from "react";
import ArtworkTabLayout from "./ArtworkTab/ArtworkTabLayout";
import ContactsTabLayout from "./ContactsTab/ContactsTabLayout";
import Inbox from "./InboxTab/Inbox";
import { EmailArtworkProvider } from "./ArtworkTab/EmailArtworkContext";
import useInbox from "./InboxTab/InboxContext";

const RenderTabContent = ({ activeTab, setActiveTab }) => {
  switch (activeTab) {
    case "inbox":
      return <Inbox activeTab={activeTab} setActiveTab={setActiveTab} />;
    case "artwork":
      return (
        <EmailArtworkProvider>
          <ArtworkTabLayout activeTab={activeTab} setActiveTab={setActiveTab} />
        </EmailArtworkProvider>
      );
    case "contacts":
      return (
        <ContactsTabLayout activeTab={activeTab} setActiveTab={setActiveTab} />
      );
    default:
      return null;
  }
};

export default function EmailsLayout() {
  /* ******************** All States ************************* */
  const { activeLabelTab: activeTab, setActiveLabelTab: setActiveTab } =
    useInbox();

  /* ******************** All Functions ************************* */

  /* ******************** All UseEffects ************************* */

  return (
    <div className="">
      {/* ******************** Tabs Content ************************* */}
      <div className="">
        <RenderTabContent activeTab={activeTab} setActiveTab={setActiveTab} />
      </div>
    </div>
  );
}
